import makeStyles from '@mui/styles/makeStyles';

const useAnimatedLoaderStyles = makeStyles({
  root: {}
});

export default useAnimatedLoaderStyles;
